module.exports = __webpack_public_path__ + "static/media/Sopas Wantan.3322d65d.svg";